// internal-deps
import { CheckoutMetaInfoResponsePayload } from "@swiggy-private/native-bridge";
import { CartAddress } from "@swiggy-private/payment-ui";

export const getItemCountAndAnnotation = (
    checkoutMetaInfo?: CheckoutMetaInfoResponsePayload | null,
): {
    cartItemsCount?: number;
    addressAnnotation?: CartAddress["annotation"];
} => ({
    cartItemsCount: checkoutMetaInfo?.cartItemsCount,
    addressAnnotation: checkoutMetaInfo?.deliveryAddress?.annotation,
});
